var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getMessages)?_c('section',[_c('div',{staticClass:"body"},[_c('chat-mensagem',{staticClass:"chatMensagem"})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }